import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save, get }    from "apps/actions/common";
import { api } from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
import { deepmerge } from 'utilities/merge';
export class FormStatus extends BaseAjaxForm {
  validFunction = null;
  submitFunction = save;
  protected mergeOpts(opts: any = null): boolean {
    this.opts = deepmerge(this.opts, this.formData())
    return super.mergeOpts(opts);
  }
  formData(){
    return this.getState().data.forms_orders_status
  }
}

riot.mixin('forms.orders.status', FormStatus as riot.TagMixin)
